import { Injectable } from '@angular/core';
import { ActivationStart, Router } from '@angular/router';

export const ID_FOR_REDIRECTION_FROM_APP: string = 'IdForRedirectionFromApp';

@Injectable({
  providedIn: 'root',
})
export class RedirectionFromAppService {
  constructor() {}

  public setRedirectionId(id: string) {
    sessionStorage.setItem(ID_FOR_REDIRECTION_FROM_APP, id);
  }

  get RedirectionId(): string | null {
    return sessionStorage.getItem(ID_FOR_REDIRECTION_FROM_APP);
  }

  public clear() {
    sessionStorage.removeItem(ID_FOR_REDIRECTION_FROM_APP);
  }
}

export function initializeIdForRedirectionFromApp(
  _router: Router,
  redirectionFromAppService: RedirectionFromAppService,
): () => Promise<void> {
  return async () =>
    new Promise((resolve) => {
      _router.events.subscribe((event) => {
        if (event instanceof ActivationStart) {
          const id = event.snapshot.params['id'];
          if (id != undefined) {
            redirectionFromAppService.setRedirectionId(id);
          }
        }
      });
      resolve();
    });
}
